<template>
    <fieldset class="ordering-settings-section" :disabled="disabled">
        <legend class="visually-hidden">{{ title }}</legend>
        <div class="ordering-settings-heading">
            <feather :type="icon" size="22" class="ordering-settings-icon" aria-hidden="true" />
            <div>
                <h2 class="fs-6 fw-bold mb-1">{{ title }}</h2>
                <p class="small text-muted mb-0">{{ description }}</p>
            </div>
        </div>
        <div class="ordering-settings-content">
            <slot />
        </div>
    </fieldset>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true },
        description: { type: String, required: true },
        icon: { type: String, required: true },
        disabled: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.ordering-settings-section { min-width: 0; margin: 0; border: 1px solid var(--bs-border-color, #dee2e6); border-radius: 20px; background: white; }
.ordering-settings-heading { display: flex; align-items: flex-start; gap: 1rem; padding: 1.25rem 1.5rem; border-bottom: 1px solid var(--bs-border-color, #dee2e6); border-radius: 20px 20px 0 0; }
.ordering-settings-icon { flex-shrink: 0; margin-top: .15rem; color: var(--main-color-light); }
.ordering-settings-content { min-width: 0; padding: 1.5rem; }
@media (max-width: 575px) {
    .ordering-settings-heading, .ordering-settings-content { padding: 1rem; }
}
</style>
